import { createSlice } from "@reduxjs/toolkit";
import ApiClientConnector from "src/api/ApiClientConnector";
import { convertToB2BUser } from "./actions/B2BUserActions";

const initialState = {
    agentList: [],
    agentUserList: [],
    b2bAgentUserList: [],
    isDetailView: false,
    isManageView: false,
    isManageB2BUserView: false,
    selectedAgentId: null
};

export const AgentManagerSlice = createSlice({
    name: 'agents',
    initialState,
    reducers: {
        getAgentList: (state, action) => {
            state.agentList = action.payload;
        },
        getB2BAgentsForUser: (state, action) => {
            state.b2bAgentUserList = action.payload;
        },
        addAgent: (state, action) => {
            state.agentUserList = [...state.agentUserList, { ...action.payload }];
        },
        setAgentUserList: (state, action) => {
            state.agentUserList = action.payload;
        },
        changeDetailView: (state, action) => {
            state.isDetailView = action.payload;
        },
        changeManageView: (state, action) => {
            state.isManageView = action.payload;
        },
        changeManageB2BUserView: (state, action) => {
            state.isManageB2BUserView = action.payload;
        },
        changeSelectedItemId: (state, action) => {
            state.selectedAgentId = action.payload;
        },
        changeAgentCountry: (state, action) => {
            const { agentId, country } = action.payload;
            const agentIndex = state.agentList.findIndex(agent => agent.Id === agentId);
            if (agentIndex !== -1) {
                state.agentList[agentIndex].Country = country;
            }
        },
        updateAgentCountryInList: (state, action) => {
            const { agentId, country } = action.payload;
            const agentIndex = state.agentList.findIndex(agent => agent.Id === agentId);
            if (agentIndex !== -1) {
                state.agentList[agentIndex].Country = country;
            }
        },
    }
})

export const {
    getAgentList,
    addAgent,
    setAgentUserList,
    getB2BAgentsForUser,
    changeDetailView,
    changeManageView,
    changeManageB2BUserView,
    changeSelectedItemId,
    changeAgentCountry,
    updateAgentCountryInList
} = AgentManagerSlice.actions;

export const fetchAgents = (instance, accounts, criteria ) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.agents.get(criteria);
    dispatch(getAgentList(result));
    return result;
}

export const fetchLookupAgents = (instance, accounts, criteria ) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.agents.getLookupAgent(criteria);
    dispatch(getAgentList(result));
    return result;
}

export const fetchB2BAgentUser = (instance, accounts, criteria) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.agents.get(criteria);
    const b2bUsers = convertToB2BUser(result);
    dispatch(getB2BAgentsForUser(b2bUsers));
    return result;
}

export const addAgentUser = (instance, accounts, data, agentId) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const response = await client.agents.post(agentId, data);
    dispatch(addAgent(response));
    return response;
};

export const updateAgentCountry = (instance, accounts, countryData, agentId) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const response = await client.agents.updateCountry(agentId, countryData);
    dispatch(updateAgentCountryInList({ agentId, country: countryData.Country }));
    return response;
};

export const fetchAgentHeaderImage = (instance, accounts, agentId) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const response = await client.agents.getImage(agentId);
    return response.blob();
};

export const uploadAgentHeaderImage = (instance, accounts, agentId, image) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const formData = new FormData();
    formData.append('file', image);

    const response = await client.agents.uploadImage(agentId, formData);
    return response;
};

export const fetchB2BAgentUserByEmail = (instance, accounts, criteria) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.agents.getEmail(criteria);
    dispatch(getB2BAgentsForUser(result));
    return result;
}

export default AgentManagerSlice.reducer;
